import { Divider, Grid } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid'
import { useParams } from 'react-router-dom'
import {
  Box,
  Card,
  Table,
  ListItem,
  TableProvider,
  CardHeader
} from 'components'
import { get } from 'lodash'
import { formatCurrency, formatDate } from 'utils'
import { useLoadOrderPayments } from 'modules/orders/hooks'
import { Order } from 'modules/orders/types'

const columnLeft: any = [
  {
    label: 'Condição de Pagamento',
    key: 'paymentTerm.name'
  }
  // {
  //   label: 'Forma de Pagamento',
  //   key: 'paymentMethod.name'
  // }
]

export const Payments = ({ order }: { order?: Order }) => {
  const { id } = useParams()

  const { data: payments } = useLoadOrderPayments(id)

  const columns: GridColDef[] = [
    // {
    //   field: 'id',
    //   headerName: 'Lançamento',
    //   flex: 1
    // },
    {
      field: 'installment',
      headerName: 'Parcela',
      flex: 1,
      renderCell: (row: any) => String(row?.value)
    },
    {
      field: 'paymentMethod',
      headerName: 'Tipo de Pagamento',
      flex: 1,
      renderCell: (row: any) => `${row?.value?.id} - ${row?.value?.name}`
    },
    {
      field: 'dueDate',
      headerName: 'Vencimento',
      flex: 1,

      headerAlign: 'right',
      align: 'right',
      renderCell: (row: any) => formatDate(row?.value)
    },
    {
      field: 'value',
      headerName: 'Total',
      flex: 1,

      headerAlign: 'right',
      align: 'right',
      renderCell: (row: any) => formatCurrency(row?.value)
    }
  ]

  return (
    <div>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={4} md={4}>
          <Card
            sx={{
              visibility: { xs: 'hidden', sm: 'visible', md: 'visible' },
              padding: { xs: 0, sm: 0, md: 0 },
              maxWidth: '100vw',
              maxHeight: '100vh'
            }}
          >
            <Box sx={{ visibility: 'visible' }}>
              <Box
                sx={{
                  padding: {
                    xs: 0,
                    sm: '0 24px 0 0',
                    md: '0px 24px 0 0px'
                  },
                  borderBottom: { xs: 'none', sm: '1px solid #E0E0E0' }
                }}
              >
                <CardHeader title="Pagamento" />
              </Box>
              <Divider
                sx={{
                  visibility: { xs: 'hidden', sm: 'visible', md: 'visible' }
                }}
              />
              <Box sx={{ padding: { xs: 0, sm: '24px', md: '24px' } }}>
                {columnLeft?.map((item: any) => (
                  <ListItem
                    key={item.key}
                    label={item.label}
                    value={get(order, item.key)}
                    transform={item?.transform}
                  />
                ))}
              </Box>
            </Box>
          </Card>
        </Grid>
        <Grid item md={8} sx={{ width: '100%' }}>
          <TableProvider>
            <Table columns={columns} rows={payments?.data} />
          </TableProvider>
        </Grid>
      </Grid>
    </div>
  )
}
